import { render } from "./SingleTransaction.vue?vue&type=template&id=6bacbc35&scoped=true"
import script from "./SingleTransaction.vue?vue&type=script&lang=js"
export * from "./SingleTransaction.vue?vue&type=script&lang=js"

import "./SingleTransaction.vue?vue&type=style&index=0&id=6bacbc35&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bacbc35"]])

export default __exports__